import { PaginationRequest, Pagination } from "./../types/pagination.type";
import { Report, ReportFilter, ReportParameter } from "./../types/report.type";
import { responseHandlerDefault } from "./../utils/handler.util";
import axios from "./api";

/**
 * report parameters
 * @param page
 * @param size
 * @param filter
 * @param timeZone
 * @returns
 */
export const getReportParameters = (
  page: number | undefined,
  size: number | undefined,
  filter: ReportFilter,
  timeZone = "UTC"
): Promise<Pagination<ReportParameter>> => {
  const params: PaginationRequest<ReportFilter> = {};
  if (page) {
    params.page = page;
  }
  if (size) {
    params.size = size;
  }
  if (filter) {
    params.filter = filter;
  }

  return axios
    .get(`/report/parameters/`, {
      params: { ...params, timeZone },
    })
    .then(responseHandlerDefault);
};

/**
 * report parameters
 * @param filter
 * @param timeZone
 * @returns
 */
export const downloadReportParameters = (
  filter: ReportFilter,
  timeZone = "UTC"
): Promise<{ fileName: string; url: string }> => {
  return axios
    .post(
      `/report/parameters/csv`,
      {
        filter,
        timeZone,
      },
      { responseType: "blob" }
    )
    .then((res) => {
      responseHandlerDefault(res);
      const match = res.headers["content-disposition"]?.match(/filename\s*=\s*"(.+)"/i);
      const fileName = match && match[1] ? match[1] : "report.csv";

      return { fileName, url: URL.createObjectURL(res.data) };
    });
};

/**
 * reports by samplingPointId
 * @param samplingPointId
 * @returns
 */
export const getReportsBySamplingPointId = (samplingPointId: number): Promise<any> => {
  return axios.get(`/report/sampling-point/${samplingPointId}`).then(responseHandlerDefault);
};

/**
 * create report
 * @param report
 * @returns
 */
export const postReport = (report: Omit<Report, "id" | "lastSendDate" | "lastSendStatus">) => {
  return axios.post(`/report/`, report).then(responseHandlerDefault);
};

/**
 * update report
 * @param id
 * @param report
 * @returns
 */
export const putReport = (id: number, report: Partial<Omit<Report, "id">>) => {
  return axios.put(`/report/${id}`, report).then(responseHandlerDefault);
};
